export default __webpack_public_path__ + "static/media/Temporary Stay Visa - Home Page.2f6f15d0.jpg";